import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePeople, useReunions } from "../hooks/hooks_index";

export default function TitleManager() {
  const location = useLocation();

  const {data: people, peopleLoading, peopleError} = usePeople();
  const {data: reunions, reunionsLoading, reunionsError} = useReunions();

  const isNotReady = 
    peopleLoading || 
    reunionsLoading ||
    peopleError ||
    reunionsError ||
    !people ||
    !reunions;

  useEffect(() => {
    if (isNotReady) return;
    if (location.pathname === "/") document.title = "Home | Spradley Family";
    if (location.pathname === "/calendar") document.title = "Calendar | Spradley Family";
    if (location.pathname === "/gallery") document.title = "Gallery | Spradley Family";
    if (location.pathname === "/directory") document.title = "Directory | Spradley Family";
    if (location.pathname === "/reunions") document.title = "Reunions | Spradley Family";
    if (location.pathname === "/map") document.title = "Map | Spradley Family";
    if (location.pathname === "/family-tree") document.title = "Family Tree | Spradley Family";
    if (location.pathname === "/edit-person") document.title = "Edit Person | Spradley Family";
    if (location.pathname === "/edit-reunion") document.title = "Edit Reunion | Spradley Family";
    if (location.pathname === "/edit-img") document.title = "Add Images | Spradley Family";
    if (location.pathname === "/profile") document.title = "Profile | Spradley Family";
    if (location.pathname === "/uploaded-photos") document.title = "Uploaded Photos | Spradley Family";
    if (location.pathname === "/edit-bio") document.title = "Edit Bio | Spradley Family";
    if (location.pathname.startsWith("/edit-reunion-bio")) document.title = "Edit Reunion | Spradley Family";
    if (location.pathname === "/edit-photos") document.title = "Edit Photos | Spradley Family";
    if (location.pathname.startsWith("/people/")) {
      const person_id = location.pathname.split("/people/")[1];
      const person = people[person_id];
      document.title = `${person.AKA || `${person.f_name} ${person.l_name}`} | Spradley Family`;
    }
    if (location.pathname.startsWith("/reunion/")) {
      const reunion_id = location.pathname.split("/reunion/")[1];
      const reunion = reunions[reunion_id];
      document.title = `${reunion.year} Reunion | Spradley Family`;
    }
  }, [location, isNotReady, people, reunions]);

  return null;
}